import o from"styled-components";const e=o.div`
	background: url(${({imageUrl:o})=>o});
	background-size: cover;
	background-position: ${({position:o})=>o?`${o.x}% ${o.y}%`:"center"};
	border-radius: ${({borderRadius:o})=>`${o}px`};
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	gap: 90px;
	height: 262px;
	padding: 12px 14px;
	position: relative;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
		pointer-events: none;
	}
`,t=o.div`
	background-color: black;
	position: absolute;
	inset: 0;
	opacity: ${({opacity:o})=>o};
`,i=o.div`
	background: none;
	border: none;
	background-color: ${({backgroundColor:o})=>o};
	color: ${({color:o})=>o};
	font-size: 18px;
	padding: 12px 18px;
	border-radius: 9999px;
	align-self: center;
	width: fit-content;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,n=o.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLinkText:o})=>o?"space-between":"end"};
	z-index: 10;
	height: 34px;
`,r=o.span`
	color: rgba(255, 255, 255, 0.6);
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,d=o.div`
	background-color: rgba(0, 0, 0, 0.6);
	padding: 7px;
	border-radius: 9999px;
	line-height: 0;
`;export{d as CardArrow,i as CardButton,e as CardContainer,n as CardFooter,r as CardLink,t as CardOverlay};
